import React from "react";
import { createRoot } from "react-dom/client";
import { Providers } from "@app/providers";
import { Router } from "@app/router";
import { ErrorBoundary } from "@shared/ui/ErrorBoundary";
import "./styles/tokens.css";
import "./styles/base.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Providers>
        <Router />
      </Providers>
    </ErrorBoundary>
  </React.StrictMode>
);
